import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitodamantaxi() {



    const cardData = {

keyword: "Mumbai to Daman Taxi",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Daman Taxi services for families, couples, corporate travelers, beach lovers, and weekend tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with professional chauffeurs for a smooth coastal journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip taxi bookings, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable trip to Daman, a charming coastal destination known for its beautiful beaches, Portuguese heritage, historic forts, churches, gardens, and relaxing seaside atmosphere.",

topPlaces: [
    {
        title: "Devka Beach",
        description:
            "Devka Beach is one of the most popular attractions in Daman and is known for its scenic coastline, peaceful atmosphere, and beautiful Arabian Sea views. Visitors enjoy leisurely walks along the shore, relaxing by the sea, and spending quality time with family and friends. The beach becomes especially attractive during sunset when the sky is painted with vibrant colors, creating a memorable coastal experience."
    },
    {
        title: "Jampore Beach",
        description:
            "Jampore Beach is famous for its calm waters, soft sandy shoreline, and family-friendly environment. It is one of the best beaches in Daman for relaxation and recreational activities. Visitors can enjoy camel rides, horse rides, beachside snacks, and water-based activities while appreciating the tranquil beauty of the coastline."
    },
    {
        title: "Moti Daman Fort",
        description:
            "Moti Daman Fort is a magnificent Portuguese-era fort that showcases the rich colonial heritage of Daman. Surrounded by massive walls and historic structures, the fort complex includes government buildings, churches, and heritage landmarks. Visitors enjoy exploring its architecture, learning about its history, and admiring views of the surrounding area."
    },
    {
        title: "Nani Daman Fort",
        description:
            "Nani Daman Fort is another important historical attraction that reflects the Portuguese influence in the region. The fort features impressive gateways, old defensive walls, and charming colonial architecture. Tourists visit to experience Daman's historical legacy while enjoying the scenic riverfront surroundings."
    },
    {
        title: "Bom Jesus Church",
        description:
            "Bom Jesus Church is one of the oldest and most beautiful churches in Daman, admired for its elegant architecture and intricate wooden interiors. The church remains an active place of worship and attracts visitors interested in religious history, architecture, and cultural heritage."
    },
    {
        title: "Our Lady of the Sea Church",
        description:
            "Our Lady of the Sea Church is a prominent religious landmark known for its peaceful atmosphere and impressive colonial-era design. The church's architecture, spiritual significance, and well-maintained surroundings make it a popular destination for both devotees and tourists exploring Daman."
    },
    {
        title: "Daman Ganga River Front",
        description:
            "The Daman Ganga River Front offers picturesque views where the river meets the Arabian Sea. Visitors enjoy evening walks, photography, boating opportunities, and relaxing moments along the waterfront. The scenic beauty of the riverfront provides a refreshing contrast to the coastal beaches."
    },
    {
        title: "Mirasol Lake Garden",
        description:
            "Mirasol Lake Garden is a beautifully developed recreational destination featuring landscaped gardens, boating facilities, amusement rides, and family-friendly attractions. The peaceful lake setting and green surroundings make it an ideal location for picnics, relaxation, and leisure activities."
    },
    {
        title: "Lighthouse at Daman",
        description:
            "The Daman Lighthouse offers panoramic views of the Arabian Sea, beaches, and surrounding coastline. Visitors appreciate the scenic beauty, cool sea breeze, and photography opportunities available from the area. The lighthouse stands as an important landmark reflecting Daman's maritime history."
    },
    {
        title: "Moti Daman Jetty and Coastal Promenade",
        description:
            "The Moti Daman Jetty and Coastal Promenade provide beautiful views of the sea, fishing boats, and historic fort walls. Visitors enjoy peaceful evening strolls, local food stalls, and spectacular sunset views along the waterfront. The combination of heritage charm and coastal scenery makes it a perfect conclusion to a Mumbai to Daman taxi journey."
    }
],



services: [
{
name: "Mumbai to Daman Taxi",
description: "Mumbai Airport Cab offers Mumbai to Daman Taxi service for comfortable, safe, and affordable travel to the popular coastal destination of Daman. Whether you are planning a family vacation, weekend getaway, corporate outing, business trip, beach holiday, group tour, or sightseeing journey, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, Force Urbania, and luxury vehicles. Our professional chauffeurs ensure a smooth highway journey with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We provide convenient pickup services from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and surrounding areas, ensuring a relaxing and hassle-free travel experience to Daman."
},
{
name: "Mumbai to Daman Cab",
description: "Book Mumbai to Daman Cab with Mumbai Airport Cab for reliable and convenient transportation. Our experienced drivers, clean AC vehicles, affordable rates, and flexible travel schedules make every journey comfortable for families, tourists, couples, and corporate travellers."
},
{
name: "Mumbai to Daman Taxi Fare",
description: "Get affordable Mumbai to Daman Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, no hidden charges, multiple vehicle options, and cost-effective packages for one way and round trip travel."
},
{
name: "Mumbai to Daman Cab Fare",
description: "Mumbai Airport Cab provides competitive Mumbai to Daman Cab Fare with professional chauffeurs, premium vehicles, reliable service, and flexible travel plans for all types of travellers."
},
{
name: "Cab from Mumbai to Daman",
description: "Choose a Cab from Mumbai to Daman with Mumbai Airport Cab and enjoy safe, comfortable, and reliable transportation with experienced drivers and well-maintained AC vehicles."
},
{
name: "Mumbai to Daman Car Rental",
description: "Book Mumbai to Daman Car Rental with chauffeur-driven vehicles for flexible travel. We offer Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury vehicle options suitable for every travel requirement."
},
{
name: "Mumbai to Daman Taxi Booking",
description: "Mumbai Airport Cab offers Mumbai to Daman Taxi Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle choices for leisure and business travel."
},
{
name: "Mumbai to Daman One Way Cab",
description: "Travel conveniently with Mumbai to Daman One Way Cab service featuring fixed pricing, comfortable AC vehicles, professional chauffeurs, and hassle-free pickup and drop facilities."
},
{
name: "Mumbai to Daman Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Daman Round Trip Cab packages for weekend vacations, family holidays, beach trips, sightseeing tours, and corporate outings with flexible schedules."
},
{
name: "Mumbai to Daman Outstation Cab",
description: "Book Mumbai to Daman Outstation Cab for comfortable long-distance travel with premium vehicles, experienced drivers, affordable fares, and customized travel packages."
},
{
name: "Mumbai to Daman Taxi Service",
description: "Mumbai Airport Cab offers Mumbai to Daman Taxi Service with safe transportation, affordable pricing, clean vehicles, and dependable chauffeurs for a stress-free travel experience."
},
{
name: "Mumbai to Daman Car Hire",
description: "Choose Mumbai to Daman Car Hire with Mumbai Airport Cab for premium chauffeur-driven travel featuring comfortable seating, flexible schedules, personalized service, and reliable transportation."
},
{
name: "Mumbai to Daman Beach Taxi",
description: "Book Mumbai to Daman Beach Taxi and enjoy direct transportation to Daman's popular beaches, resorts, waterfront attractions, and holiday destinations with complete comfort and convenience."
},
{
name: "Mumbai to Daman Weekend Cab",
description: "Mumbai Airport Cab offers Mumbai to Daman Weekend Cab service for couples, families, and groups planning relaxing weekend getaways with flexible pickup timings and comfortable vehicles."
},
{
name: "Mumbai Airport to Daman Taxi",
description: "Book Mumbai Airport to Daman Taxi with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, professional chauffeurs, and comfortable AC vehicles."
},
{
name: "Navi Mumbai to Daman Cab",
description: "Mumbai Airport Cab provides Navi Mumbai to Daman Cab service with doorstep pickup, affordable fares, premium vehicles, and dependable transportation for leisure and business travellers."
},
{
name: "Thane to Daman Cab",
description: "Choose Thane to Daman Cab with Mumbai Airport Cab for reliable transportation, experienced drivers, comfortable vehicles, and flexible travel schedules designed for a smooth journey."
},
{
name: "Mumbai to Daman SUV Cab",
description: "Mumbai Airport Cab offers Mumbai to Daman SUV Cab service for larger families and groups seeking spacious interiors, premium comfort, ample luggage capacity, and smooth highway travel."
},
{
name: "Mumbai to Daman Innova Cab",
description: "Book Mumbai to Daman Innova Cab with Mumbai Airport Cab for spacious seating, premium comfort, professional chauffeur service, and reliable transportation ideal for families and small groups."
}
],

tableData: [
["Mumbai to Daman Taxi","Mumbai to Daman Cab"],
["Mumbai to Daman Taxi Fare","Mumbai to Daman Cab Fare"],
["Cab from Mumbai to Daman","Mumbai to Daman Car Rental"],
["Mumbai to Daman Taxi Booking","Mumbai to Daman One Way Cab"],
["Mumbai to Daman Round Trip Cab","Mumbai to Daman Outstation Cab"],
["Mumbai to Daman Taxi Service","Mumbai to Daman Car Hire"],
["Mumbai to Daman Beach Taxi","Mumbai to Daman Weekend Cab"],
["Mumbai Airport to Daman Taxi","Navi Mumbai to Daman Cab"],
["Thane to Daman Cab","Mumbai to Daman SUV Cab"],
["Mumbai to Daman Innova Cab","Mumbai to Daman Family Trip Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Daman Taxi Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Daman Taxi services for families, tourists, couples, business travelers, and weekend vacationers seeking comfortable transportation."
},
{
WhyChooseheading: "Perfect Coastal Getaway Travel",
WhyChoosedescription: "Daman is a popular beach destination known for its scenic coastline, Portuguese heritage, resorts, and relaxing atmosphere, making it ideal for short vacations."
},
{
WhyChooseheading: "Comfortable Long-Distance Journey",
WhyChoosedescription: "Our well-maintained vehicles and experienced drivers ensure a smooth and enjoyable travel experience from Mumbai to Daman."
},
{
WhyChooseheading: "Wide Range of Vehicle Choices",
WhyChoosedescription: "Customers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to their travel needs and group size."
},
{
WhyChooseheading: "One-Way and Round Trip Options",
WhyChoosedescription: "Whether you need a one-way taxi, round trip package, weekend getaway, or customized sightseeing itinerary, we offer flexible booking solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and surrounding areas."
},
{
WhyChooseheading: "Safe and Professional Travel Experience",
WhyChoosedescription: "Our trained drivers prioritize safety, punctuality, and customer comfort to ensure a stress-free journey."
},
{
WhyChooseheading: "Ideal for Families and Group Tours",
WhyChoosedescription: "From beach vacations and family trips to corporate outings and group tours, we provide suitable transportation options for every traveler."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Daman Taxi services?",
answer: "Daman is famous for its beaches, resorts, churches, forts, and coastal attractions, making it a preferred destination for leisure travelers."
},
{
question: "Can I book a one-way taxi from Mumbai to Daman?",
answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Daman travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, and SUVs are among the most preferred options for comfortable travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return trips depending on their travel plans and schedule."
},
{
question: "Can families use this service for vacations?",
answer: "Yes, many families choose Mumbai Airport Cabs for beach holidays, weekend trips, and leisure vacations in Daman."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate teams, and sightseeing tours."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can sightseeing locations be included during the trip?",
answer: "Yes, customers can visit Devka Beach, Jampore Beach, Moti Daman Fort, St. Jerome Fort, and other popular attractions."
},
{
question: "Is advance booking recommended for Mumbai to Daman travel?",
answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning, especially during weekends and holidays."
},
{
question: "How can I book a Mumbai to Daman Taxi?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Prakash Naik",
feedback:
"The journey to Daman was smooth and relaxing. The vehicle was in excellent condition and the driver ensured a comfortable ride throughout the trip.",
rating: 5
},
{
id: 2,
name: "Mrs. Bhavna Mehta",
feedback:
"Mumbai Airport Cabs provided outstanding service for our beach vacation. The cab was clean, punctual, and the entire travel experience exceeded our expectations.",
rating: 5
}
];




































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Daman Taxi",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-daman-cab.jpg",
"description": "Book Mumbai to Daman taxi service for a smooth and affordable coastal trip. Mumbai Airport Cabs offers reliable cab service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options for Daman travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-daman-taxi"
}
};









    return (
        <div>


<Helmet>
  <title>Mumbai to Daman Taxi | Cab Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Daman taxi service at affordable fares. Safe and comfortable cab service with professional drivers, one-way and round-trip options, and hassle-free coastal travel."
/>

<meta
 name="keywords"
 content="mumbai to daman taxi, mumbai to daman cab, mumbai to daman taxi fare, mumbai to daman cab fare, cab from mumbai to daman, mumbai to daman car rental, mumbai to daman taxi booking, mumbai to daman one way cab, mumbai to daman round trip cab, daman taxi from mumbai, outstation cab mumbai to daman, mumbai daman cab service, affordable taxi mumbai to daman, best cab service mumbai to daman"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/116.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitodamantaxi;